import React, { useState } from 'react';
import { pets, owners } from '../mock/petsData';
import PetProfileCard from '../components/PetProfileCard';
import PetProfilePage from './PetProfilePage';

const PetsDashboardPage = () => {
  const [selectedPet, setSelectedPet] = useState(null);

  if (selectedPet) {
    return <PetProfilePage petId={selectedPet} />;
  }

  return (
    <div className="ml-48 p-4">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Mascohijos</h2>
        <button className="flex items-center px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Nuevo Mascohijo
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {pets.map(pet => {
          const owner = owners.find(o => o.id === pet.ownerId);
          return (
            <div 
              key={pet.id} 
              onClick={() => setSelectedPet(pet.id)}
              className="cursor-pointer hover:shadow-md transition-shadow"
            >
              <PetProfileCard pet={pet} owner={owner} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PetsDashboardPage;